const URL_PATTERN = /((http|ftp|https):\/\/)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i;
export const containsURLOrEmail = (input)=>{
    if (input && input.trim().length > 0) {
        return URL_PATTERN.test(input.trim());
    }
    return false;
};
